import { Control, Controller } from 'react-hook-form';
import { BsChevronDown } from 'react-icons/bs';
import Select, { Props } from 'react-select';

export interface SelectControllerProps {
  control: Control<Record<string, any>>;
  options: Record<string, unknown>[];
  name: string;
  placeholder: string;
  isMulti?: boolean;
  components?: Partial<Props['components']>;
  onChange?: (value: string) => void;
  menuPortalTarget?: HTMLElement;
  isClearable?: boolean;
  returnOnlyValue?: boolean;
}

export const SelectController = ({
  control,
  name,
  placeholder,
  options,
  isMulti = true,
  components = {},
  isClearable = true,
  onChange: externalOnChange,
  returnOnlyValue = false,
}: SelectControllerProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Select
          onFocus={(event) => {
            event.stopPropagation();
          }}
          className="select-input"
          classNamePrefix="select-input"
          placeholder={placeholder}
          isClearable={isClearable}
          menuPortalTarget={document.body}
          id={name}
          isMulti={isMulti}
          closeMenuOnSelect={true}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => <BsChevronDown className="me-2" />,
            ...components,
          }}
          options={options}
          value={
            isMulti
              ? options.filter((option) => value?.includes(option.value))
              : options.find((option) => option.value === value) || null
          }
          onChange={(selection) => {
            if (isMulti) {
              onChange((selection as unknown as { value: string }[]).map((option) => option.value));
            } else {
              onChange((selection as { value: string })?.value ?? '');
            }

            if (returnOnlyValue && externalOnChange) {
              externalOnChange((selection as { value: string })?.value ?? '');
            } else {
              if (externalOnChange) {
                externalOnChange(selection as string);
              }
            }
          }}
        />
      )}
    />
  );
};
